<template>
  <v-container class="py-4 koneko-access-admin">
    <v-card class="pa-4 mb-4">
      <v-row align="center">
        <v-col cols="12" md="8">
          <h2 class="mb-1">Koneko A — access control</h2>
          <p class="subtitle-2 grey--text text--darken-1 mb-0">
            Choose which panels, nav items, and dashboard sections each person
            sees. Saves to the <strong>Koneko access API</strong> when available
            (all users on refresh); this browser also keeps a copy for offline
            testing. <strong>View as</strong> uses these caps immediately.
          </p>
        </v-col>
        <v-col cols="12" md="4" class="text-md-right">
          <v-btn
            class="ma-1"
            small
            outlined
            color="primary"
            :to="{name: 'KonekoA'}"
          >
            Back to Koneko A
          </v-btn>
          <v-btn class="ma-1" small outlined :to="{name: 'DashboardPage'}">
            Dashboard
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <v-alert v-if="!adminAllowed" type="warning" outlined class="mb-3">
      Not authorized. Redirecting…
    </v-alert>

    <KonekoVisibilitySettingsPanel
      v-else
      scope="koneko-a"
      @saved="onVisibilitySaved"
    />
  </v-container>
</template>

<script>
import {mapGetters} from "vuex";
import KonekoVisibilitySettingsPanel from "@/components/Koneko/KonekoVisibilitySettingsPanel.vue";
import {isKonekoAccessControlUser} from "@/config/konekoAConfig";
import {bumpKonekoVisibilityOverrides} from "@/utils/dashboardViewAsSync";

export default {
  name: "KonekoAAccessAdminView",
  components: {KonekoVisibilitySettingsPanel},
  computed: {
    ...mapGetters(["userProfileData"]),
    adminAllowed() {
      return isKonekoAccessControlUser(this.userProfileData);
    },
  },
  mounted() {
    if (!this.adminAllowed) {
      this.$router.replace({name: "KonekoA"});
    }
  },
  methods: {
    async onVisibilitySaved() {
      const {loadServerVisibilityOverrides} = await import(
        "@/config/konekoVisibility"
      );
      await loadServerVisibilityOverrides();
      bumpKonekoVisibilityOverrides();
    },
  },
};
</script>

<style scoped>
.koneko-access-admin {
  max-width: 1400px;
}
</style>
